import { render, staticRenderFns } from "./HistoryItemTypeStatus.vue?vue&type=template&id=20927434&scoped=true&"
import script from "./HistoryItemTypeStatus.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeStatus.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeStatus.vue?vue&type=style&index=0&id=20927434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20927434",
  null
  
)

export default component.exports